import {useEffect, useState} from "react";
import fetch from "node-fetch";
import {API_ENDPOINTS} from "../../config";
import {IMGTYPES} from "../../imgUploadConfig";

const ImageUploadComponent =  ({onImageUpload, image, IMGTYPE, id=1}) => {

    const[isUploading, setIsUploading] = useState(false);
    const[imgURL, setImgURL] = useState('');

    useEffect(() => {
        setImgURL(image);
    }, [image]);

    const handleImageUpload = async (event) => {
        setIsUploading(true);
        const file = event.target.files[0];
        if(!file){
            setIsUploading(false);
            return;
        }

        const formData = new FormData();
        formData.append('image', file);
        formData.append('IMGTYPE', JSON.stringify(IMGTYPE))

        const token = localStorage.getItem('token');


        try {
            const response = await fetch(API_ENDPOINTS.uploadImage, {
                method: 'POST',
                headers : {
                    'Authorization': `Bearer ${token}`
                },
                body:  formData
            });

            const data = await response.json();
            console.log('Image uploaded: ', data.imageUrl);
            //OnImageUpload => Function from caller
            onImageUpload(data.imageUrl);
            setImgURL(data.imageUrl);
        } catch (error){
            console.error('Error uploading image:', error);
        } finally {
            setIsUploading(false);
        }
    }

    return (
        <div className={'flex flex-col gap-10 m-4'}>
            {!isUploading && <input type="file" onChange={handleImageUpload} disabled={isUploading}/>}
            {isUploading && <p>Uploading...</p>}
            <img src={imgURL} className={'w-1/5'}/>
        </div>
    );

}


export default ImageUploadComponent;